import FormSuccessModal from './FormSuccessModal';

export default FormSuccessModal;
